export { userGroupListScreen, userGroupDetailScreen } from './user-group.screen';
export { userGroupListSearch, userGroupDetailSearch } from './user-group.search';
export { loadUserGroupMessages } from './user-group.catalog';
export const loadUserGroupScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadUserGroupGuides = () => import('./user-group.guide');
